import React, { useState } from "react";
import Button from "../../common/components/Button";
import PropTypes from "prop-types";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { Paper } from "@mui/material";

const InstructionTable = ({ loading, data, onAddAll }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  if (loading) {
    return (
      <LoadingSpinner
        style={{ margin: "80px auto", position: "relative", top: "unset" }}
      />
    );
  }

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleAddAll = async () => {
    if (isAdding) return;

    const idsToAdd = selectedIds.slice();
    if (idsToAdd.length === 0) return;

    try {
      setIsAdding(true);
      await Promise.resolve(onAddAll(idsToAdd)); 
      setSelectedIds([]); 
    } finally {
      setIsAdding(false);
    }
  };

    const disabled = selectedIds.length === 0 || isAdding;

  return (
    <div style={{ width: "100%" }}>
      {/* Add All button */}
       <div style={{ marginBottom: 16, textAlign: "right" }}>
        <button
          type="button"
          className="button-secondary"
          onClick={handleAddAll}
          disabled={disabled}
          style={{
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          {isAdding ? "Adding..." : "Add All"}
        </button>
      </div>

  <table
          style={{ overflow: "initial", padding: 0 }}
          className="table study"
        >
          <tbody>
            <tr>
              <th>Select</th>
              <th>ID</th>
              <th style={{ width: "100%" }}>Name</th>
            </tr>
            {data.map((item, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="checkbox"
                    style={{
                      width: "16px",
                      height: "16px",
                      visibility: "visible",
                      display: "inline-block",
                    }}
                    checked={selectedIds.includes(item.step_id)}
                    onChange={() => toggleSelect(item.step_id)}
                  />
                </td>
                <td>{item.step_id}</td>
                <td>{item.instruction_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
    </div>
  );
};

InstructionTable.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
  onAddAll: PropTypes.func,
};

export default InstructionTable;
